import { z } from 'zod';
import { zPrintErrorType } from '../enums';

export const printAttemptSchema = z.object({
  errorId: z.string().nullable().default(null),
  errorPrinterStatus: z.string().nullable().default(null),
  errorType: zPrintErrorType.nullable().default(null),
  localCreatedAt: z.number(),
  printedAt: z.number().nullable().default(null),
  uuid: z.string(),
});
export type PrintAttempt = z.output<typeof printAttemptSchema>;

export const printAttemptStrictSchema = printAttemptSchema.safeExtend({
  uuid: z.guid(),
});
